import { useQuery } from 'react-query';

import { useRequest } from '@frontend/api';
import type { QueryFunction } from '@frontend/api';

import type {
  OrderListData,
  UseOrderListParams,
  OrderListQueryKey,
} from './types';
import { getOrderListQueryKey } from './util';

export const useOrderList: QueryFunction<
  OrderListData,
  [UseOrderListParams],
  OrderListQueryKey
> = (params, { requestOptions, queryOptions } = {}) => {
  const queryKey = getOrderListQueryKey(params);
  const request = useRequest(requestOptions);

  return useQuery({
    ...queryOptions,
    queryKey,
    queryFn: ({ signal }) => {
      const {
        locator,
        query: { status, ...searchParams },
      } = params;
      return request(`/orders/groups/${locator}`, {
        init: {
          method: 'GET',
          signal,
        },
        query: {
          ...searchParams,
          ...(status !== 'all' && { status }),
        },
      });
    },
  });
};
